var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c("list-seller",_vm._b({tag:"component",on:{"updateCart":function($event){return _vm.$emit("updateCart", $event)},"removeFromCart":function($event){return _vm.$emit("removeFromCart")}}},'component',_vm.productProps,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }